import React from 'react'
import { faBoxAlt } from '@fortawesome/pro-regular-svg-icons/faBoxAlt'
import { faBoxAlt as faBoxSolidAlt } from '@fortawesome/pro-solid-svg-icons/faBoxAlt'
import { isRouteAllowed, reverse } from 'src/routes/config'
import MainMenuItem from 'src/components/Menu/MainMenuItem'
import isFeatureEnabled, { FEATURES } from 'src/utils/isFeatureEnabled'
import useTranslations from 'src/hooks/useTranslations'
import getEnvVariableValue, { VARIABLES } from 'src/utils/getEnvVariableValue'
import useUserData from 'src/hooks/useUserData'

const baseUrlHorizon = getEnvVariableValue(VARIABLES.OLD_HORIZON_BASE_URL)

export default function ServicePortfolioMenu({
    parentIsCollapsed,
    isOpen,
    onClick,
}) {
    const { t } = useTranslations('MainMenu', 'MainMenu')
    const userData = useUserData()
    return (
        <MainMenuItem
            icon={faBoxAlt}
            iconActive={faBoxSolidAlt}
            title={t('Service & portfolio')}
            isOpen={isOpen}
            onClick={onClick}
            parentIsCollapsed={parentIsCollapsed}
        >
            {isRouteAllowed(userData, 'service-portfolio-overview') &&
                isFeatureEnabled(
                    FEATURES.SERVICE_PORTFOLIO_OVERVIEW_MENU_OPTION
                ) && (
                    <MainMenuItem
                        title={t('Overview')}
                        to={reverse('service-portfolio-overview')}
                    />
                )}
            {isRouteAllowed(userData, 'order-catalog') && (
                <MainMenuItem
                    title={t('Order catalog')}
                    to={
                        isFeatureEnabled(FEATURES.SERVICE_PORTFOLIO_MENU)
                            ? reverse('order-catalog')
                            : {
                                  pathname: `${baseUrlHorizon}/service-portfolio-management`,
                              }
                    }
                    externalLink={
                        !isFeatureEnabled(FEATURES.SERVICE_PORTFOLIO_MENU)
                    }
                />
            )}
            {isRouteAllowed(userData, 'orders') && (
                <MainMenuItem title={t('Orders')} to={reverse('orders')} />
            )}
        </MainMenuItem>
    )
}
